import Stickyfill from 'stickyfilljs';
import $ from 'jquery';

var scrollAnimation;

export default class ScrollAnimation {
  constructor(config) {
    this._windowObj = $(window);
    this._container = config.container;
    this._containerSection = $(this._container).find('.section__in');
    this._nextEl = $(this._container).nextAll('.packaging__text');
    this._video = $(this._container).find('video');
    this._videoDuration = this._video.attr('data-duration');
    //this._videoScrollHeight = this._video.attr('data-scrollheight');
    this._videoScrollHeight = this._windowObj.height() * 2;
    this._videoFPS = this._video.attr('data-fps');
    this._startBefore = this._windowObj.height() / 1.5;

    this._animationId;

    this._videoContainer = this._container.find('.packaging__package');
    //this._videoText = this._container.find('.packaging__text');
    this._videoHeadline = this._container.find('.packaging__title');

    this._bottomVideo;
    this._videoScrollHeightActual;
    this._nextTop;

    this._reset();
    this._init();
  }

  _reset() {
    this._animationId = undefined;

    this._container.height('auto');
    //this._video.removeAttr('controls');    
    this._container.removeClass('non-sticky');
    this._container.removeClass('sticky');
    this._videoContainer.css('height', 'auto');
    this._videoHeadline.css('opacity', 1);
	
    var that = this;
	
    this._video[0].addEventListener('loadedmetadata', function() {
      that._video[0].currentTime = 0;
    }, false);	
  }

  _init() {
    if (this._video.length < 1) {
      return;
    }

    var videoRatio = (this._video.width() + 40) / (this._video.height() + 189);
    //alert(videoRatio);
    //alert(this._windowObj.width() / this._windowObj.height());

    if (this._windowObj.width() / this._windowObj.height() < videoRatio * 0.9) {
      this._container.addClass('non-sticky');
      //this._video.attr('controls', 'controls');

      var that = this;

      this._windowObj.scroll(function() {
        if (that._videoContainer.offset().top - that._startBefore < that._windowObj.scrollTop()) {
          if (that._video[0].currentTime < 0.1 ) {
            setTimeout(function() { that._video[0].play(); }, 300);
          }
        }
      });


      return;
    }

    this._container.addClass('sticky');
    Stickyfill.addOne(this._containerSection);

    this._container.height(this._videoScrollHeight);

    this._video[0].load();
    this._video[0].pause();

    this._videoScrollHeightActual = this._videoScrollHeight - $(window).height();

    scrollAnimation = this;

    /*
     scrollAnimation._animate(true);
     $( window ).scroll(function() {
     scrollAnimation._animate();
     });
     */

    scrollAnimation._video[0].addEventListener('loadedmetadata', function() {
      scrollAnimation._animationId = window.requestAnimationFrame(scrollAnimation._animate);
    }, false); 
  }

  _normalizeTime(time, fps) {
    return parseInt(time * fps) / fps;
  }

  _animate(force) {
    var that = scrollAnimation;

    that._nextTop = that._nextEl.offset().top;
    //that._bottomVideo = that._nextTop - that._videoScrollHeight + that._videoContainer.height();
    that._bottomVideo = that._nextTop - that._videoScrollHeight + that._video.outerHeight(true);

    var bottomWindow = that._windowObj.scrollTop() + that._windowObj.height();

    var percentage = (bottomWindow - that._bottomVideo) / that._videoScrollHeightActual;

    //console.log('bottomWindow: ' + bottomWindow + ' that._bottomVideo: ' + that._bottomVideo + ':percentage: ' + percentage);

    if (percentage < 0) {
      percentage = 0;
    }

    if (percentage > 1) {
      percentage = 1;
    }

    var windowCurrentVideoPart =  percentage * that._videoDuration;

    if(force || (percentage < 1 || percentage > 0)) {
      that._video[0].currentTime = that._normalizeTime(windowCurrentVideoPart, that._videoFPS);

      var videoContainerHeight = that._video.height();

      if (percentage < 0.3) {
        videoContainerHeight = videoContainerHeight * (0.7 + percentage / 0.3 * 0.3);
      }


      if(that._windowObj.height() < 480) {
        videoContainerHeight = that._video.height();
      }

      that._videoContainer.css('height', 'calc(' + videoContainerHeight + 'px)' );
      //that._videoContainer.css('height', 'calc(100vh - 227px)' );

      //that._videoText.css('opacity', percentage * 3 - 2 );
      //that._containerSection.css('top', (that._windowObj.height() - that._containerSection.height() - 40) + 'px' );

      that._videoHeadline.css('opacity', percentage * 1.5);
      //that._videoHeadline.css('margin-bottom', (percentage * 40) + 'px');

      if (that._video.width() > that._videoContainer.width()) {
        that._video.css('left', ((that._video.width() - that._videoContainer.width()) / -2) + 'px' );
      }
      else {
        that._video.css('left', '0px' );
      }

    }

    Stickyfill.refreshAll();

    scrollAnimation._animationId = window.requestAnimationFrame(that._animate);
  }
}
